export default [
  {
    text: 'Report date',
    value: 'report_date',
  },
  {
    text: 'Daily clickouts',
    value: 'daily_clickouts',
    tooltip: 'CPCReportsTableDailyClickouts',
  },
  {
    text: 'Daily commission',
    value: 'daily_commission',
    tooltip: 'CPCReportsTableDailyCommission',
  },
];
